<template>
  <div class="wrapper">
    <div class="container">
      <div class="top l_flex_row_between">
        <div class="nub">共{{ total }}份作品</div>
        <div class="search-box">
          <el-input v-model="searchText" placeholder="请输入关键字" @keyup.native.enter="search">
            <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
      <!-- 筛选 -->
      <div class="selection-box">
        <div class="row l_flex_row">
          <div class="name">类型：</div>
          <div class="list-box l_flex_row">
            <div
              class="item"
              v-for="(item, index) in typeList"
              :key="index"
              :class="{ active: index == currentType }"
              @click="typeChange(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="row l_flex_row">
          <div class="name">省份：</div>
          <div class="list-box l_flex_row">
            <div
              class="item"
              v-for="(item, index) in provinceList"
              :key="index"
              :class="{ active: index == currentProvince }"
              @click="provinceChange(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="row l_flex_row">
          <div class="name">精选：</div>
          <div class="list-box l_flex_row">
            <div
              class="item"
              v-for="(item, index) in sortList"
              :key="index"
              :class="{ active: index == currentSort }"
              @click="sortChange(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <!-- groupList -->
        <div class="row l_flex_row">
          <div class="name">组别：</div>
          <div class="list-box l_flex_row">
            <div
              class="item"
              v-for="(item, index) in groupList"
              :key="index"
              :class="{ active: index == currentGroup }"
              @click="groupChange(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="list-wrap">
        <work-item class="item" v-for="(item, index) in datalist" :key="index" :obj="item"></work-item>
      </div>
      <!-- empty -->
      <el-empty v-if="total == 0" description="暂无数据"></el-empty>

      <!-- 分页  -->
      <div class="pagination l_flex_row_center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total,  prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import workItem from "@/components/workItem";
export default {
  name: "workshow",
  components: {
    workItem,
  },
  props: {},
  data() {
    return {
      typeList: [
        {
          name: "全部",
          active: true,
        },
        {
          name: "诵读",
          active: false,
        },
        {
          name: "吟诵",
          active: false,
        },
        {
          name: "吟诵",
          active: false,
        },
      ],
      provinceList: [
        {
          name: "全部",
          active: true,
        },
        {
          name: "安徽省",
          active: false,
        },
        {
          name: "河北省",
          active: false,
        },
        {
          name: "湖南省",
          active: false,
        },
      ],
      sortList: [
        {
          name: "全部",
          active: true,
        },
        {
          name: "推荐",
          active: false,
        },
        {
          name: "选送",
          active: false,
        },
      ],
      groupList:[],
      currentPage: 1,
      currentType: 0,
      currentProvince: 0,
      currentSort: 0,
      searchText: "",
      total: 1,
      datalist: [],
      pageSize: 16,
      keywords: "", //
      currentGroup:0,
    };
  },
  watch: {},
  computed: {
    // 省份
    province() {
      return this.provinceList[this.currentProvince].code;
    },
    // 排序
    sort() {
      return this.sortList[this.currentSort].code;
    },
    activityType() {
      return this.typeList[this.currentType].code;
    },
    group(){
      return this.groupList[this.currentGroup].code;
    }
  },
  methods: {
    handleCurrentChange(e) {
      // console.log(e);
      this.currentPage = e;
      this.getWrokList(this.currentPage, this.keywords, this.sort, this.province,this.activityType, this.group);
    },
    // 类型选择
    typeChange(e) {
      // console.log("type", e);
      this.currentType = e;
      this.currentPage = 1;
      // console.log("type---", this.activityType);
      // this.getWrokList(this.currentPage, this.keywords, this.sort, this.province, this.activityType);
      this.getWrokList(this.currentPage, this.keywords, this.sort, this.province,this.activityType, this.group);
      // this.typeList.forEach((el, index) => {
      //   el.active = e == index ? true : false;
      // });
    },
    // 省份选择
    provinceChange(e) {
      this.currentProvince = e;
      this.currentPage = 1;
      // console.log('省份选择',this.province);
      // this.getWrokList(this.currentPage, this.keywords, this.sort, this.province, this.activityType);
      this.getWrokList(this.currentPage, this.keywords, this.sort, this.province,this.activityType, this.group);
      // this.provinceList.forEach((el, index) => {
      //   el.active = e == index ? true : false;
      // });
    },
    // 排序选择
    sortChange(e) {
      this.currentSort = e;
      this.currentPage = 1;
      // this.getWrokList(this.currentPage, this.keywords, this.sort, this.province, this.activityType);
      this.getWrokList(this.currentPage, this.keywords, this.sort, this.province,this.activityType, this.group);

      // this.sortList.forEach((el, index) => {
      //   el.active = e == index ? true : false;
      // });
    },
    groupChange(index,item){
      this.currentGroup = index;
      this.currentPage = 1;
      this.getWrokList(this.currentPage, this.keywords, this.sort, this.province,this.activityType, this.group);


    }
    ,
    //  获取作品列表
    async getWrokList(page = 1, keywords = "", is_push = "", province = "", activity_id = "",group='') {
      try {
        this.searchText = keywords;
        const res = await this.$api.getWorksListByHome({
          params: {
            page: page,
            "per-page": this.pageSize,
          },
          data: {
            keywords: keywords,
            is_push: is_push,
            province: province,
            activity_id: activity_id,
            group:group,
          },
        });
        this.datalist = res.data.works_list;
        this.total = res.data.works_num;
        // console.log("res", res);
      } catch (error) {
        console.error("err", error);
      }
    },
    // 搜索
    search() {
      // console.log("search", this.searchText);
      this.keywords = this.searchText;
      this.currentType = 0;
      this.currentSort = 0;
      this.currentProvince = 0;
      this.currentPage = 1;
      // this.getWrokList(this.currentPage, this.keywords, this.sort, this.province, this.activityType);
      this.getWrokList(this.currentPage, this.keywords, this.sort, this.province,this.activityType, this.group);
    },
    // 获取检索条件
    async getSearchCondition() {
      try {
        const res = await this.$api.getSearchCondition();
        this.typeList = res.data.activity_id;
        this.provinceList = res.data.province;
        this.sortList = res.data.is_push;
        this.groupList  = res.data.group;
        // console.log("res", res);
      } catch (error) {
        console.log("err", error);
      }
    },
  },
  created() {
    this.getWrokList();
    this.getSearchCondition();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  font-size: 15px;
  .container {
    width: 1200px;
    margin: 0 auto 50px;
    background-color: #ffff;
    min-height: 100vh;
    padding: 50px 40px;
    border-radius: 10px;
    box-sizing: border-box;
    .top {
      .nub {
        color: #815a4e;
        font-size: 20px;
        font-weight: bold;
      }
    }
    .row {
      padding: 30px 0;
      border-bottom: 1px solid #eeeeee;
      .name {
        width: 45px;
        margin-right: 30px;
        margin-bottom: 10px;
        border-bottom: 1px solid transparent;
        color: #4c4948;
        opacity: 0.5;
      }
      .list-box {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        .item {
          cursor: pointer;
          margin-right: 30px;
          margin-bottom: 10px;
          border-bottom: 1px solid transparent;
          // width: calc((1200px - 8px - 80px - (26px * 3))/4);
          &.active {
            color: #815a4e;
          }
          &:hover {
            color: #815a4e;
            border-bottom: 1px solid #815a4e;
          }
        }
      }
    }
    .list-wrap {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin: 0 26px 0 0;
        width: calc((1200px - 8px - 80px - (26px * 3)) / 4);
        margin-bottom: 40px;
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
